import type { PublicationCode } from '@/scopes/common/domain/types'
import type { Usp } from '../../pages/SearchPage/components/Results/Usps'
import { ELIZA_PUBLICATION_CODES, SUNWEB_PUBLICATION_CODES } from '@/constants'

const SEARCH_PAGE_USPS: Record<string, string[]> = {
  SZ: ['/laagste-prijsgarantie', '/flexibel-omruilen', '/vakantiegarantie'],
  KZ: ['/prisgaranti', '/fleksibel-og-gratis-aendring-af-rejse', '/rejser/sunweb-only'],
  QZ: ['/lagsta-prisgaranti', '/flexibel-ombokning', '/solresor/res-tryggt-med-sunweb'],
  FZ: ['/garantie-prix-le-plus-bas', '/echange-flexible', '/paiement-plusieurs-fois'],
  FS: ['/fr/garantie-prix-le-plus-bas', '/fr/echange-flexible', '/fr/aeroports'],
  BZ: ['/nl/laagste-prijsgarantie', '/nl/flexibel-omruilen', '/nl/vakantiegarantie'],
}

export function getSearchPageUSPs(publicationCode: PublicationCode): Usp[] | null {
  if (!SEARCH_PAGE_USPS[publicationCode]) {
    return null
  }

  return [
    {
      translation: 'search_results_usp1',
      link: SEARCH_PAGE_USPS[publicationCode][0],
    },
    {
      translation: 'search_results_usp2',
      link: SEARCH_PAGE_USPS[publicationCode][1],
    },
    {
      translation: 'search_results_usp3',
      link: SEARCH_PAGE_USPS[publicationCode][2],
    },
  ]
}

export function getPlpHeroImageUrl(publicationCode: PublicationCode, staticMediaServerBaseUrl: string | null) {
  if (!staticMediaServerBaseUrl) {
    return ''
  }

  if (SUNWEB_PUBLICATION_CODES.winter.includes(publicationCode)) {
    return `${staticMediaServerBaseUrl}/bg_qs_winter.jpg`
  }

  if (SUNWEB_PUBLICATION_CODES.summer.includes(publicationCode)) {
    return `${staticMediaServerBaseUrl}/bg_qs_sun.jpg`
  }

  if (ELIZA_PUBLICATION_CODES.includes(publicationCode)) {
    return `${staticMediaServerBaseUrl}/bg_qs_eliza.jpg`
  }

  return ''
}
